define('pages/track-speed-page',["require", "exports", "../baseline/hotkeys", "../charts/dataseries", "../charts/flight-stats", "../charts/polar-sustained", "../charts/timechart", "../replay/replay", "../tracks/track-enabled"], function (require, exports, hotkeys, dataseries, flightStats, polar, timechart_1, replay, trackEnabled) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    function init(trackId) {
        polar.init(); // Sustained polar
        hotkeys.init();
        replay.init();
        initTime(trackId);
        flightStats.init(true); // must be after time series enabling
    }
    exports.init = init;
    /**
     * Add extra data series
     */
    function initTime(trackId) {
        // Disable some data series that are enabled by default
        dataseries.all.find(function (s) { return s.name === "Horizontal"; }).enabled = false;
        dataseries.all.find(function (s) { return s.name === "Vertical"; }).enabled = false;
        dataseries.all.find(function (s) { return s.name === "Glide ratio"; }).enabled = false;
        // Create time chart with extra speed
        var timeChart = new timechart_1.TimeChart("#speed-chart", dataseries.all);
        trackEnabled.trackEnabled.subscribe(function (track) {
            timeChart.loadTrack(track);
        });
        trackEnabled.addTrack(trackId);
    }
});
//# sourceMappingURL=/assets/javascripts/pages/track-speed-page.js.map;
